module.exports = __webpack_public_path__ + "media/images/monthly5-efffae8a8068a2fb46e6db04acc1dfdf.jpg";